import { dataModelsModule } from "./dataModels/dataModels.module";
import { UserService } from "./services/user.service";
import { LayoutService } from "./services/layout.service";
import { GUARDSFactory } from "./services/routes-guards.factory";
import { NavigationStack } from "./services/router-actions.service";
import { ApiHttpService, configureApiInterceptors } from "./services/api-http.service";
import { AuthenticationNew, configureAuthInterceptors } from "./services/authentication.service";
import { MealPlanService } from "./services/meal-plan.service";
import { Profile } from "./services/profile.service";
import { GroceryListService } from "./services/grocery-list.service";
import { TempCheckin } from "./services/tempcheckin.service";
import { Exercisetracker } from "./services/exercisetracker.service";
import { MeasurementSystem } from "./services/msystem.service";
import { ValidateBmi } from "./services/validatebmi.service";
import { ValidateBodyfat } from "./services/validatebodyfat.service";
import { FreeFood } from "./services/freefood.service";
import { SyncFactory, configureSyncInterceptors } from "./services/sync.service";
import { ApiFirebaseService } from "./services/api-firebase.service";
import { AppVersionChangedModalInstanceCtrl, AppVersionChanged } from "./services/app-version-changed.service";
import { UnitRangeService } from "./services/unit-range.service";


export var coreModule = angular.
module('gplans.core', [dataModelsModule.name]).
factory('GUARDS', GUARDSFactory).
service('ApiHttp', ApiHttpService).
service('ApiFirebase', ApiFirebaseService).
service('UserService', UserService).
service('LayoutService', LayoutService).
service('NavigationStack', NavigationStack).
service('MealPlanService', MealPlanService).
service('GroceryListService', GroceryListService).
service('UnitRangeService', UnitRangeService).

factory('TempCheckin', TempCheckin).
factory('Exercisetracker', Exercisetracker).
factory('MeasurementSystem', MeasurementSystem).
factory('AuthenticationNew', AuthenticationNew).
factory('Authentication', AuthenticationNew).
factory('Profile', Profile).
factory('ValidateBmi', ValidateBmi).
factory('ValidateBodyfat', ValidateBodyfat).
factory('FreeFood', FreeFood).
factory('Sync', SyncFactory).
factory('AppVersionChanged', AppVersionChanged).
controller('AppVersionChangedModalInstanceCtrl', AppVersionChangedModalInstanceCtrl).

config(configureAuthInterceptors).
config(configureApiInterceptors).
config(configureSyncInterceptors);